import { useState } from 'react';

type DuplicateIntroProps = {
  onStart?: (showIntroAgain: boolean) => void;
};

export function DuplicateIntro({ onStart }: DuplicateIntroProps) {
  const [skipIntro, setSkipIntro] = useState<boolean>(false);

  return (
    <>
      <h3 className="mx-3 mb-4 py-2">How to use web2print templates</h3>
      <div className="row w2p-info-toolboard mx-0">
        <div className="col-1">&nbsp;</div>
        <div className="col-2">
          <img src="/themes/custom/ebm-linde/public/images/copy.svg" alt="" />
        </div>
        <div className="col-9">
          <h2>Step 1</h2>
          <p>
            Click "Start" to create your own version of a template.
            <br />
            Assign a new title, short description and tags.
          </p>
          <p></p>
        </div>
      </div>

      <div className="row w2p-info-toolboard mx-0">
        <div className="col-1">&nbsp;</div>
        <div className="col-2">
          <img src="/themes/custom/ebm-linde/public/images/edit.svg" alt="" />
        </div>
        <div className="col-9">
          <h2>Step 2</h2>
          <p>Click "Continue" to start editing your template.</p>
        </div>
        <p>
          <br />
        </p>
      </div>

      <div className="row w2p-info-toolboard mx-0">
        <div className="col-1">&nbsp;</div>
        <div className="col-2">
          <img src="/themes/custom/ebm-linde/public/images/edit_finished.svg" alt="" />
        </div>
        <div className="col-9">
          <h2>Result</h2>
          <p>
            Once you have finalised the document, it will be available in "MyWeb2Print files" in the Web2Print tool.
          </p>
        </div>
      </div>
      <br />
      <br />
      <div className="row w2p-info-toolboard mx-0 mt-2">
        <div className="col-12">
          <hr className="text-white" />
        </div>
      </div>
      <br />
      <div className="row w2p-info-toolboard mx-0">
        <div className="col-2">&nbsp;</div>
        <div className="col-10">
          <form className="mb-4">
            <input
              type="checkbox"
              id="form_show_intro"
              onChange={e => {
                setSkipIntro(e.target.checked === true);
              }}
            />
            <label htmlFor="form_show_intro">Don't show this message again</label>
          </form>
          <button
            onClick={() => onStart(skipIntro)}
            className="button c-button c-button--dark u-padding-horizontal-lg mb-4"
          >
            Start
          </button>
        </div>
      </div>
    </>
  );
}
